<template>
  <span v-html="displayText"></span>
</template>

<script>
/* eslint-disable */
import Terms from '@/services/terms.js'

export default {
  name: 'Localize',
  components: {

  },
  props: {
    text: String,
  },
  computed: {
    displayText: function () {
      return Terms.replace(this.text)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
